import React, { useRef, useLayoutEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./about.css";

gsap.registerPlugin(ScrollTrigger);

const ZoomImage = ({ scale = 4.5, duration = 1, ease = "power2.out" }) => {
  const firstImageRef = useRef(null);
  const secondImageRef = useRef(null);
  const firstTextRef = useRef(null);
  const secondTextRef = useRef(null);

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      gsap.from(firstImageRef.current, {
        scale: 1 / scale,
        opacity: 0,
        ease: ease,
        duration: duration,
        scrollTrigger: {
          trigger: firstImageRef.current,
          scrub: 1,
          start: "top 80%",
          end: "bottom 80%",
        },
      });

      gsap.from(firstTextRef.current, {
        x: -100,
        opacity: 0,
        ease: "none",
        scrollTrigger: {
          trigger: firstTextRef.current,
          scrub: true,
          start: "top 80%",
          end: "top 30%",
        },
      });

      gsap.from(secondImageRef.current, {
        scale: 1 / scale,
        opacity: 0,
        ease: ease,
        duration: duration,
        scrollTrigger: {
          trigger: secondImageRef.current,
          scrub: 1,
          start: "top 80%",
          end: "bottom 80%",
        },
      });

      gsap.from(secondTextRef.current, {
        x: 100,
        opacity: 0,
        ease: "none",
        scrollTrigger: {
          trigger: secondTextRef.current,
          scrub: true,
          start: "top 80%",
          end: "top 30%",
        },
      });
    });

    return () => ctx.revert();
  }, [scale, duration, ease]);

  return (
    <div className="about-container">
      {/* Founder Section */}
      <section className="about-section">
        <img ref={firstImageRef} src="/assets/image12.jpg" alt="Founder" className="about-image" />
        <div className="about-text" ref={firstTextRef}>
          <h3>About </h3>
          <h5>Vaira Maaligai</h5>
          <p style={{color:'black'}}>
            Vaira Maaligai is a cornerstone in the jewelry market of Salem, Tamil Nadu.
            Specializing in custom-designed jewelry and precious gemstones, the store has built a trusted
            legacy of excellence.
          </p>
        </div>
      </section>

      {/* Vision Section */}
      <section className="about-section reverse">
        <div className="about-text" ref={secondTextRef}>
          <h3>Our Legacy and Vision</h3>
          <h5>Vaira Maaligai</h5>
          <p style={{ color: 'black' }}>
            Known for exclusive 22KT gold jewelry, silver items, and wedding essentials, we offer personalized pieces
            perfect for engagements and milestone celebrations.
          </p>
        </div>
        <img ref={secondImageRef} src="/assets/image13.jpg" alt="Vision" className="about-image" />
      </section>
    </div>
  );
};

export default ZoomImage;